import React, {PropTypes} from "react";
import Constants from "../../classes/constants"

class DisplayTable extends React.Component {

  constructor() {
    super();
    this.state = {empId : null, profilePic: Constants.defaultProfilePicture[0]}
  }

  componentDidMount() {
      this.setState({empId: this.props.empNo});
      if(this.props.data.imageUrl){
         this.setState({profilePic: this.props.data.imageUrl});
      }else{
        this.setState({profilePic: Constants.defaultProfilePicture[0]});
      }
  }

  componentWillReceiveProps(nextProps) {
      let empno = nextProps.empNo;
      this.setState({empId: empno});
      if(nextProps.data.imageUrl){
        this.setState({profilePic: nextProps.data.imageUrl});
      }else{
        this.setState({profilePic: Constants.defaultProfilePicture[0]});
      }
  }


  render() {


    return (
      <div>
        <div className="col-md-3">
          <div >
              <img src={this.state.profilePic} height={this.props.height} width={this.props.width}/>

          </div>
        </div>
        <div className="col-md-9">


          <table className="table table-bordered" cellpadding="0" cellspacing="0" border="0">
            <thead>
            <tr>
              <thead>
              </thead>

            </tr>
            </thead>
            <tbody>

            <tr>
              <td style={{align: 'left'}}>EmailId :</td>
              <td style={{align: 'left'}}>
                <span id="ContentPlaceHolder1_lblDOB" className="GenText">{this.props.data.emailId}</span>
              </td>
              <td style={{align: 'left'}}>Ph No:</td>
              <td style={{align: 'left'}}>
                <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">{this.props.data.contactNo}</span>
              </td>
            </tr>
            <tr>
              <td style={{align: 'left'}}>Department :</td>
              <td style={{align: 'left'}}>
                <span id="ContentPlaceHolder1_lblDOB" className="GenText">{this.props.data.department}</span>
              </td>
              <td style={{align: 'left'}}>Sub Dept:</td>
              <td style={{align: 'left'}}>
                <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">{this.props.data.subDepartment}</span>
              </td>
            </tr>
            <tr>
              <td style={{align: 'left'}}>Function:</td>
              <td style={{align: 'left'}}>
                <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">{this.props.data.function}</span>
              </td>
              <td style={{align: 'left'}}>Vertical :</td>
              <td style={{align: 'left'}}>
                <span id="ContentPlaceHolder1_lblDOB" className="GenText">{this.props.data.vertical}</span>
              </td>

            </tr>
            <tr>
              <td style={{align: 'left'}}>Reporting To:</td>
              <td style={{align: 'left'}}>
                <span id="ContentPlaceHolder1_lblDOB" className="GenText">{this.props.data.managerName}</span>
              </td>
              <td style={{align: 'left'}}>Vertical Head:</td>
              <td style={{align: 'left'}}>
                <span id="ContentPlaceHolder1_lblAnniversary"
                      className="GenText">{this.props.data.verticalHeadName}</span>
              </td>
            </tr>
            <tr>
              <td style={{align: 'left'}}>Designation:</td>
              <td style={{align: 'left'}}>
                <span id="ContentPlaceHolder1_lblDOB" className="GenText">{this.props.data.designation}</span>
              </td>
              <td style={{align: 'left'}}>Location:</td>
              <td style={{align: 'left'}}>
                <span id="ContentPlaceHolder1_lblDOB" className="GenText">{this.props.data.location}</span>
              </td>
            </tr>


            </tbody>
          </table>


        </div>


      </div>
    );
  }
}

DisplayTable.propTypes = {};

export default DisplayTable;





/** WEBPACK FOOTER **
 ** ./src/components/common/DisplayTable.js
 **/